/*
 * ROCANIIRU customization
 * File: assets/rc-event-menu.js
 * Version: v1.0.0
 * Date: 2026-06-29
 *
 * Switches mega-d's Event category, article list, intro, and hero image.
 */

if (!customElements.get('rc-event-menu')) {
  customElements.define(
    'rc-event-menu',
    class RcEventMenu extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) {
          return;
        }

        this.isInitialized = true;
        this.categories = Array.from(this.querySelectorAll('[data-rc-mega-d-category]'));
        this.eventPanels = Array.from(this.querySelectorAll('[data-rc-mega-d-event-panel]'));
        this.eventLinks = Array.from(this.querySelectorAll('[data-rc-mega-d-detail]'));
        this.detailTemplates = Array.from(this.querySelectorAll('[data-rc-mega-d-detail-template]'));
        this.detailStage = this.querySelector('[data-rc-mega-d-detail-stage]');

        this.categories.forEach((category) => {
          const activate = () => this.activateCategory(category.dataset.rcMegaDCategory, true);

          category.addEventListener('mouseenter', activate);
          category.addEventListener('focus', activate);
        });

        this.eventLinks.forEach((eventLink) => {
          const activate = () => {
            this.activateCategory(eventLink.dataset.rcMegaDParentCategory, false);
            this.showDetail(eventLink.dataset.rcMegaDDetail);
          };

          eventLink.addEventListener('mouseenter', activate);
          eventLink.addEventListener('focus', activate);
        });

        this.activateCategory(this.dataset.initialCategory || this.categories[0]?.dataset.rcMegaDCategory, true);
      }

      activateCategory(categoryId, resetDetail) {
        if (!categoryId) {
          return;
        }

        this.categories.forEach((category) => {
          const isActive = category.dataset.rcMegaDCategory === categoryId;
          category.classList.toggle('is-active', isActive);
          category.setAttribute('aria-expanded', String(isActive));
        });

        this.eventPanels.forEach((panel) => {
          panel.hidden = panel.dataset.rcMegaDEventPanel !== categoryId;
        });

        if (resetDetail) {
          const panel = this.getEventPanel(categoryId);
          this.showDetail(panel?.dataset.defaultDetailTemplate);
        }
      }

      showDetail(templateId) {
        if (!this.detailStage) {
          return;
        }

        this.eventLinks.forEach((eventLink) => {
          eventLink.classList.toggle('is-active', eventLink.dataset.rcMegaDDetail === templateId);
        });

        const template = this.detailTemplates.find((item) => item.dataset.rcMegaDDetailTemplate === templateId);

        this.detailStage.classList.remove('is-image-visible');

        if (!template) {
          this.detailStage.replaceChildren();
          this.detailStage.dataset.activeTemplate = '';
          return;
        }

        this.detailStage.replaceChildren(template.content.cloneNode(true));
        this.detailStage.dataset.activeTemplate = templateId;

        const image = this.detailStage.querySelector('.mega-menu-d__hero-image');

        if (!image || image.complete) {
          window.requestAnimationFrame(() => this.revealImage(templateId));
          return;
        }

        const reveal = () => this.revealImage(templateId);

        image.addEventListener('load', reveal, { once: true });
        image.addEventListener('error', reveal, { once: true });
      }

      revealImage(templateId) {
        if (this.detailStage?.dataset.activeTemplate === templateId) {
          this.detailStage.classList.add('is-image-visible');
        }
      }

      getEventPanel(categoryId) {
        return this.eventPanels.find((panel) => panel.dataset.rcMegaDEventPanel === categoryId);
      }
    }
  );
}
